import { JobTitle, JobTitleEnum } from '../job-title';

export interface SalaryCalculatorFallbackEntry {
  highSalary: number;
  lowSalary: number;
}

const DEPUTY_FALLBACK_PREFIX = 'deputy_' as const;

export type SalaryCalculatorFallbackKey = JobTitleEnum | `${typeof DEPUTY_FALLBACK_PREFIX}${JobTitleEnum}`;

export const getSalaryCalculatorFallbackKey = ({ deputy, title }: Pick<JobTitle, 'deputy' | 'title'>): SalaryCalculatorFallbackKey =>
  (deputy ? `${DEPUTY_FALLBACK_PREFIX}${title}` : title) as SalaryCalculatorFallbackKey;

export const SALARY_CALCULATOR_FALLBACK_DATA: Partial<Record<SalaryCalculatorFallbackKey, SalaryCalculatorFallbackEntry>> = {
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.UnitManager, deputy: true })]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.Osteopath]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.AssistantElderlyCareNurse]: { lowSalary: 3250, highSalary: 3700 },
  [JobTitleEnum.QualityManagement]: { lowSalary: 3700, highSalary: 4650 },
  [JobTitleEnum.AssistantNurse]: { lowSalary: 3250, highSalary: 3700 },
  [JobTitleEnum.Others]: { lowSalary: 3000, highSalary: 3350 },
  [JobTitleEnum.ChemistAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.NursingSpecialistHealthCare]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.OccupationalTherapist]: { lowSalary: 3150, highSalary: 3600 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.NursingSupervisor, deputy: true })]: { lowSalary: 3700, highSalary: 4650 },
  [JobTitleEnum.ElderlyCareNurse]: { lowSalary: 3850, highSalary: 4350 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.ResidentialSectorManager, deputy: true })]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.NursingSupervisor]: { lowSalary: 4500, highSalary: 5550 },
  [JobTitleEnum.Paramedic]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.UnitManager]: { lowSalary: 3700, highSalary: 5150 },
  [JobTitleEnum.NursingSpecialistGeriatric]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.LaboratoryAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.AssistantRemedialCareNurse]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.QualifiedDentalEmployee]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.Midwife]: { lowSalary: 3950, highSalary: 4450 },
  [JobTitleEnum.PhysicalTherapist]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.MedicalAssistance]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.RemedialCareNurse]: { lowSalary: 3700, highSalary: 4200 },
  [JobTitleEnum.IntensiveCareTechnicalAssistance]: { lowSalary: 3750, highSalary: 4250 },
  [JobTitleEnum.Instructor]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.AnestheticAssistant]: { lowSalary: 3750, highSalary: 4250 },
  [JobTitleEnum.CareerChangers]: { lowSalary: 3000, highSalary: 3400 },
  [JobTitleEnum.FunctionalDiagnosticsAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.RadiologyAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.Companion]: { lowSalary: 3000, highSalary: 3350 },
  [JobTitleEnum.PracticeManager]: { lowSalary: 3700, highSalary: 4700 },
  [JobTitleEnum.Nurse]: { lowSalary: 3850, highSalary: 4350 },
  [JobTitleEnum.TechnicalAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.TeamLeader, deputy: true })]: { lowSalary: 3750, highSalary: 4750 },
  [JobTitleEnum.HygieneSpecialist]: { lowSalary: 3700, highSalary: 4650 },
  [JobTitleEnum.SpeechTherapist]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.SurgeryAssistant]: { lowSalary: 3750, highSalary: 4250 },
  [JobTitleEnum.ResidentialSectorManager]: { lowSalary: 3900, highSalary: 5200 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.HomeManager, deputy: true })]: { lowSalary: 4650, highSalary: 5400 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.NursingDirector, deputy: true })]: { lowSalary: 3700, highSalary: 4650 },
  [JobTitleEnum.NursingDirector]: { lowSalary: 4500, highSalary: 5550 },
  [getSalaryCalculatorFallbackKey({ title: JobTitleEnum.Instructor, deputy: true })]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.HomeManager]: { lowSalary: 4750, highSalary: 6200 },
  [JobTitleEnum.PediatricNurse]: { lowSalary: 3850, highSalary: 4350 },
  [JobTitleEnum.Apprenticeship]: { lowSalary: 1150, highSalary: 1350 },
  [JobTitleEnum.PharmaceuticalAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.TeamLeader]: { lowSalary: 3850, highSalary: 4850 },
  [JobTitleEnum.MedicalAssistant]: { lowSalary: 3150, highSalary: 3600 },
  [JobTitleEnum.AdministrativeStaff]: { lowSalary: 3650, highSalary: 4100 },
  [JobTitleEnum.OperationAssistant]: { lowSalary: 3750, highSalary: 4250 },
};
